import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GerinusService } from '../lib/gerinus.service';

@Injectable()
export class ProccessHistoryService extends GerinusService {
    constructor(public http: HttpClient) {
        super(http);
        this.entityName = 'processo_historico';
        this.idField = 'PRCH_CodigoHistorico';
    }
}
